import { ZEE5_BASE_ADDRESS } from './ApiConstants';

export enum PAGE_NAME_CONSTANTS {
  HOME = 'home',
  PREMIUM = 'premium',
  SHOW_LANDING = 'show_landing',
  SHOW_DETAIL = 'show_detail',
  SHOWS_LANGUAGE = 'shows_language',
  SHOWS_GENRE = 'shows_genre',
  SHOWS_LANGUAGE_GENRE = 'shows_language_genre',
  SHOWS_GENRE_LANGUAGE = 'shows_genre_language',
  SHOWS_TRENDING = 'shows_trending',
  SHOWS_CHANNEL = 'shows_channel',
  EPISODE_DETAIL = 'episode_detail',
  MOVIE_LANDING = 'movie_landing',
  MOVIE_DETAIL = 'movie_detail',
  MOVIE_LANGUAGE = 'movie_language',
  MOVIE_GENRE = 'movie_genre',
  MOVIE_YEAR = 'movie_year',
  NEWS_LANDING = 'news_landing',
  NEWS_DETAIL = 'news_detail',
  VIDEO_LANDING = 'video_landing',
  VIDEO_DETAIL = 'video_detail',
  ZEE5_ORIGINAL_LANDING = 'zee5originals_landing',
  ZEE5_ORIGINAL_DETAIL = 'zee5originals_detail',
  WEB_SERIES_LANGUAGE = 'web_series_language',
  WEB_SERIES_GENRE = 'web_series_genre',
  WEB_SERIES_LANGUAGE_GENRE = 'web_series_language_genre',
  WEB_SERIES_GENRE_LANGUAGE = 'web_series_genre_language',
  KIDS_LANDING = 'kids_landing',
  FREE_MOVIES_LANDING = 'free_movies_landing',
  CLUB_LANDING = 'club_landing',
  KIDS_SHOW_DETAIL = 'kids_show_detail',
  KIDS_EPISODE_DETAIL = 'kids_episode_detail',
  KIDS_MOVIE_DETAIL = 'kids_movie_detail',
  KIDS_VIDEO_DETAIL = 'kids_video_detail',
  KIDS_SEASON_VIEW_ALL = 'kids_season_view_all',
  UPCOMING_LANDING = 'upcoming_landing',
  STORIES_LANDING = 'stories_landing',
  MUSIC_LANDING = 'music_videos_landing',
  PLAY_LANDING = 'play_landing',
  MUSIC_DETAIL = 'music_videos_detail',
  VIEW_ALL = 'view_all',
  LIVE_TV = 'live_tv',
  LIVETV_PREMIUMCHANNELS = 'live_tv_premium_channels',
  LIVETV_FREECHANNELS = 'live_tv_free_channels',
  LIVETV_LANGUAGE = 'live_tv_language_page',
  LIVETV_GENRE = 'live_tv_genre_page',
  LIVETV_LANGUAGE_GENRE = 'live_tv_language_genre_page',
  TV_GUIDE = 'tv_guide',
  CHANNEL_DETAIL = 'channel_detail',
  MOVIE_VIEW_ALL = 'movies_view_all',
  VIDEOS_VIEW_ALL = 'videos_view_all',
  ZEE5_ORIGINALS_VIEW_ALL = 'zee_originals_view all',
  MUSICS_VIEW_ALL = 'music_view all',
  LIVETV = 'livetv_Channel',
  CHANNELS = 'channels',
  TV_SHOWS_VIEW_ALL = 'tv_shows_view_all',
  ABOUT_US = 'about_us',
  FAQS = 'help',
  CONTACT_US = 'contact_us',
  SETTINGS = 'settings',
  SEARCH = 'search',
  SEASON_VIEW_ALL = 'season_view_all',
  TERMS_OF_USE = 'terms_of_use',
  PAYMENT = 'payment_page',
  PRIVACY_POLICY = 'privacy_policy',
  MY_PROFILE = 'my_profile',
  MY_PROFILE_REMINDER = 'my_profile_reminders',
  MY_PROFILE_WATCHLIST = 'my_profile_watchlist',
  MY_PROFILE_CHANGE_PASSWORD = 'my_profile_change_password',
  MY_PROFILE_EDIT_PROFILE = 'user_profile_edit_profile',
  SIGN_IN = 'sign_in',
  REGISTER = 'register',
  ACCOUNT_INFO = 'account_info',
  FORGOT_PASSWORD = 'forgot_password',
  RESET_PASSWORD = 'reset_password',
  FORGOT_SET_PASSWORD_MOBILE = 'forgot_set_password_mobile',
  FORGOT_PASSWORD_VERIFY_MOBILE = 'forgot_password_verify_mobile',
  MY_PROFILE_PAYMENTS = 'my_profile_payments',
  MY_PROFILE_PLANS = 'my_profile_plans',
  MY_PROFILE_RENTALS = 'my_profile_rentals',
  PACK_SELECTION = 'pack_selection',
  PARENTAL_CONTROL = 'parental_control',
  // PAYMENT_SUCCESS= "payment_success", // Removed as per mixpanel sheet for new subscription PWA2-7279
  ORDER_SUMMARY_SCREEN = 'Order Summary Screen',
  PAYMENT_FAILURE = 'payment_failure',
  OTP_PAGE = 'otp_page',
  SEASONS = 'seasons',
  DEVICE_AUTHENTICATION = 'device_authentication',
  SUBSCRIPTION = 'Subscription',
  LIVE_TV_NEWS_CHANNELS = 'live_tv_news_channels',
  ZEE5_APP_LANDING = 'zee5-appLanding',
  EDUAURAA_SUCCESS = 'eduauraa_success',
  PLEX_LANDING = 'zee_plex_landing',
  TV_CHANNEL = 'tv_channel_landing',
  TV_CHANNEL_DETAIL = 'tv_channel_detail',
  MORE_SECTION = 'more_section',
  COMBO_PACK = 'combo_pack',
  LEARNING = 'learning',
  STUDENT = 'student',
  USREFERRAL = 'Refer Details Screen',
  EDUAURAA = 'eduauraa',
  USER_PROFILE_EDIT_CHANGE_PASSWORD = 'USER_PROFILE_EDIT_CHANGE_PASSWORD'
}
//Constants to be used for Nav bar as well
export enum CONSUMPTION_PAGES {
  CHANNEL = 'channel'
}

export const LINE_COUNTS_THRESHOLD = 3;
export const CHOOSE_MORE_LANGUAGES = 'Choose more languages';
export const YES_WOULD = 'Yes, I would';
export const ConsumptionPageStringEnums = {
  EPISODE: 'Episode',
  TVEPISODE: 'TVEpisode',
  SHARE: 'Share',
  WATCHLIST: 'Watchlist',
  CAST: 'Cast',
  WATCH_TRAILER: 'Watch Trailer',
  AUDIO_LANGUAGE: 'Audio Language',
  LANGUAGE: 'language',
  SUBTITLES: 'Subtitles',
  AVAILABLE: 'Available in',
  MORE_EPISODES: 'More Episodes',
  MOVIES: 'Movies',
  CREATORS: 'Creators',
  DIRECTOR: 'Director',
  MUSIC_DIRECTOR: 'Music Director',
  EMBED: 'Embed',
  EMBED_VIDEO: 'Embed Video',
  //TODO: why? try using a marker
  EMBED_FRAMEBORDER_TEXT1: `<iframe width=560 height=315 src=${ZEE5_BASE_ADDRESS}/zee5embed?contentId= &autoplay=true  frameBorder="0" allow="autoplay;encrypted-media" allowFullScreen />`,
  EMBED_FRAMEBORDER_TEXT2: `&autoplay=true" frameBorder="0" allow="autoplay;encrypted-media" allowFullScreen />`,
  EMBED_START_TIME: 'Start at',
  FAVOURITES: 'Favourites',
  NA: 'NA'
};
export enum CHROME_VERSION_POPUP_ASSETS {
  ZEE5_LOGO = '/webapp-assets/images/ZEE5_logo.svg',
  CLOSE_ICON = '/webapp-assets/images/closeIconBlack.svg',
  SAFE_VIEW_IMAGE = '/webapp-assets/images/safeViewImage.png'
}
export const CHROME_UPDATE_REDIRECT_URI_FOR_DEVICES: {
  [key: string]: string;
} = {
  web: 'https://www.google.com/chrome/update/',
  andriod: 'https://play.google.com/store/apps/details?id=com.android.chrome',
  IOS: 'https://apps.apple.com/app/chrome-web-browser-by-google/id535886823',
  otherDevice: 'https://www.google.com/chrome/update/',
  baseUrl: ''
};
export enum DEVICE_TYPES {
  ANDRIOD = 'android',
  IOS = 'IOS',
  WEB = 'web'
}

export enum SPAPIStateEnum {
  UNINITIALIZED,
  IN_PROGRESS,
  FINISHED
}
